import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const DocumentPaper3LinesIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0343 19.6154C17.7518 19.6154 19.1447 18.2225 19.1447 16.505V7.49502C19.1447 5.77754 17.7518 4.38461 16.0343 4.38461H8.58168C6.8642 4.38461 5.47128 5.77754 5.47128 7.49502L5.47128 16.505C5.47128 18.2225 6.8642 19.6154 8.58168 19.6154H16.0343ZM20.5293 16.505C20.5293 18.9872 18.5165 21 16.0343 21H8.58168C6.09943 21 4.08666 18.9872 4.08666 16.505V7.49502C4.08666 5.01277 6.09943 3 8.58168 3H16.0343C18.5165 3 20.5293 5.01277 20.5293 7.49502V16.505Z"
        fill={props.fill || "currentColor" || "black"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0562 15.8619C16.0562 16.2442 15.7462 16.5542 15.3639 16.5542H13.0323C12.65 16.5542 12.34 16.2442 12.34 15.8619C12.34 15.4795 12.65 15.1696 13.0323 15.1696H15.3639C15.7462 15.1696 16.0562 15.4795 16.0562 15.8619ZM16.0566 12.1264C16.0566 12.5087 15.7467 12.8187 15.3643 12.8187H9.25343C8.87109 12.8187 8.56112 12.5087 8.56112 12.1264C8.56112 11.7441 8.87109 11.4341 9.25343 11.4341H15.3643C15.7467 11.4341 16.0566 11.7441 16.0566 12.1264ZM16.0566 8.38221C16.0566 8.76455 15.7467 9.07452 15.3643 9.07452H9.25343C8.87109 9.07452 8.56112 8.76455 8.56112 8.38221C8.56112 7.99978 8.87109 7.6899 9.25343 7.6899H15.3643C15.7467 7.6899 16.0566 7.99978 16.0566 8.38221Z"
        fill={props.fill || "currentColor" || "black"}
      />
    </svg>
  );
};

export default DocumentPaper3LinesIcon;
